<template>
  <div class="text-gray-900 pt-52" style="padding-bottom: 51vh">
    <div class="flex space-x-16 px-14">
      <div class="flex-1">
        <div class="text-4xl font-bold text-gray-900 tracking-tight">
          {{ group.title }}
        </div>
        <div class="mt-2 text-gray-700 leading-7 tracking-wide">
          {{ group.desc }}
        </div>
      </div>
      <div class="flex-1"></div>
    </div>
    <div class="mt-32">
      <div v-for="section in group.sections" v-bind:key="section.id">
        <MainSection
          :section="section"
          :id="section.id"
          style="scroll-margin-top: 4rem"
        ></MainSection>
      </div>
    </div>
  </div>
</template>
<script>
import MainSection from "./MainSection.vue";

export default {
  components: { MainSection },
  name: "GroupPage",
  data: () => {},
  props: ["group"],
  mounted() {
    const group = document.getElementById("group");
    var past = "";
    group.onscroll = () => {
      if (!this.group.sections) {
        return;
      }

      let elms = [];

      this.group.sections.forEach((section) => {
        const elm = document.getElementById(section.id);
        if (
          document.getElementById(section.id).getBoundingClientRect().top +
            window.innerHeight / 1.5 +
            50 <=
          group.clientHeight
        ) {
          elms.push(elm);
        }
      });

      elms = elms.sort((a, b) => {
        if (a.getBoundingClientRect().top < b.getBoundingClientRect().top) {
          return 1;
        }

        return -1;
      });

      if (elms.length === 0) {
        return;
      }

      if (elms[0].id !== past) {
        console.log(elms[0].id);
        past = elms[0].id;
        if (window.onSectionSelection) {
          window.onSectionSelection(this.group.id, elms[0].id);
        }
      }
    };
  },
  methods: {},
};
</script>
